import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";

import { getUserActivity } from "../../../APIS"; // ✅ NEW API

const ActivityTrackerTable = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const token = userDetails?.token;

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getUserActivity(token); // ✅ NEW API CALL

      if (response.success && Array.isArray(response.data)) {
        setData(response.data);
      } else {
        setData([]);
      }
    } catch (err) {
      setError("Failed to fetch Activity Data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openUserDetail = (id) => {
    window.open(`/admin/activity_logs?${id}`, "_blank");
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title m-0">Activity Tracker</h4>

        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search user..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="card-body">
        {loading && <p className="text-center fw-bold">Loading...</p>}
        {error && <p className="text-danger text-center">{error}</p>}

        <div className="table-responsive">
          <table className="table table-striped align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Assigned</th>
                <th>Completed</th>
                <th>Ongoing</th>
                <th>Pending</th>
                <th>Created</th>
                <th>Last Activity</th>
                <th>Activity Logs</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((u, i) => (
                  <tr key={u._id}>
                    <td>{i + 1}</td>
                    <td>{u.name}</td>
                    <td>{u.assignedTasks}</td>
                    <td className="text-success fw-bold">{u.completedTasks}</td>
                    <td className="text-warning fw-bold">{u.ongoingTasks}</td>
                    <td className="text-danger fw-bold">{u.pendingTasks}</td>
                    <td>{u.createdTasks}</td>
                    <td>
                      {u.lastActivity
                        ? new Date(u.lastActivity).toLocaleString()
                        : "—"}
                    </td>

                    <td>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => openUserDetail(u._id)}
                        title="View Details"
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ActivityTrackerTable;
